import React, { useMemo } from "react";
import { DBG_ON } from "../utils/dbg";

export default function PricingDebug({ quote, multiplier}) {
  if (!DBG_ON) return null;
  const styles = {
    box: {
      position: "fixed", bottom: 10, right: 10, zIndex: 9999,
      maxWidth: 420, maxHeight: "50vh", overflow: "auto",
      background: "rgba(0,0,0,0.8)", color: "#d7ffd7",
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
      fontSize: 12, padding: 12, borderRadius: 10, border: "1px solid #2a5"
    },
    h: { margin: "0 0 6px", fontWeight: 700 },
    pre: { whiteSpace: "pre-wrap", margin: 0 }
  };

  const summary = useMemo(() => ({
    code: quote?.code,
    currency: quote?.currency,
    euro_rate: Number(quote?.euro_rate) || 117,
    PRICE_MULTIPLIER: multiplier,
    counts: {
      materials: quote?.materials?.items?.length ?? 0,
      equipment: quote?.equipment?.items?.length ?? 0,
      services:  quote?.services?.items?.length  ?? 0,
    },
    totals: {
      materials: quote?.materials?.total ?? 0,
      equipment: quote?.equipment?.total ?? 0,
      services:  quote?.services?.total  ?? 0,
      grand:     quote?.grand_total      ?? 0
    }
  }), [quote, multiplier]);

  return (
    <div style={styles.box}>
      <div style={styles.h}>PRICING DEBUG</div>
      <pre style={styles.pre}>{JSON.stringify(summary, null, 2)}</pre>
    </div>
  );
}
